export const config = {decimalPlaces:2}